import { AutogenModelTableProperty, AutogenRowTableProperty } from "./autogen/AutogenModelTableProperty";

export class ModelTableProperty extends AutogenModelTableProperty<RowTableProperty> {
	constructor() {
		super(RowTableProperty);
	}
}

export class RowTableProperty extends AutogenRowTableProperty {
}
